import type { RouteObject } from "react-router-dom";

export const temporalRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Return temporal dashboard" },
    async lazy() {
      const { Page } = await import("../../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { TemporalDashboardPage } = await import(
            "./temporal-dashboard"
          );
          return { Component: TemporalDashboardPage };
        },
      },
    ],
  },
];
